import { useLocalePath } from "@commercekit/remix";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";

interface CampaignConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error: string | null;
}

const CampaignConsent = ({ checked, onChange, error }: CampaignConsentProps) => {
  const { $pt } = usePrismicLabels();
  const localePath = useLocalePath();
  return (
    <div className="campaign-consent">
      <label className="campaign-consent__label">
        <input
          type="checkbox"
          name="consent"
          value="true"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="campaign-consent__checkbox"
        />
        <span className="campaign-consent__text">
          {$pt("campaign_consent_before_link")}{" "}
          <a href={localePath("/algemene-voorwaarden")} className="link">
            {$pt("campaign_terms_link_text")}
          </a>{" "}
          {$pt("campaign_consent_after_link")}
        </span>
      </label>
      {error && (
        <p className="error-label campaign-consent__error">{error}</p>
      )}
    </div>
  );
};

export default CampaignConsent;
